<template>
  <div class="row">
    <div class="total-members-by-individual-plan">
      <div class="split-title">
        <h5>Total Members By Individual Carrier</h5>
        <a href="javascript:void(0);" @click="openModal">View All</a>
      </div>
      <div class="spline-chart" v-if="memberByPlan['records']">
        <apexchart type="bar" height="400" width="95%" :options="getComputedChartOptions" :series="getComputedSeries"
          :key="chartKey">

        </apexchart>
      </div>
      <div v-else>
        <p>{{ dataEmptyMessage }}</p>
      </div>
    </div>
    <member-plan-modal v-if="showModal" :modal.sync="showModal" :modalData.sync="modalData" keyLabel="carrier_name"
      valueLabel="total" tableHeadingLeft="Carrier Name" />
  </div>
</template>
<script>
import Api from "@/resource/Api";
import MemberPlanModal from "../modal/MemberPlanModal";
export default {
  name: "TotalMembersByIndividualPlan",
  components: {
    "member-plan-modal": MemberPlanModal,
  },
  data() {
    return {
      memberByPlan: {},
      showModal: false,
      dataEmptyMessage: "Currently there is no data",
      xaxisTotal: 4,
      xaxisLabelLength: 10,
      modalData: {},
      chartKey: 0,

    };
  },
  props: {
    groupId: {
      type: String,
      required: false,
    },
  },
  watch: {
    groupId(newId) {
      this.getMemberByPlan(newId);
    },

    memberByPlan: {
      handler(newVal) {
        if (newVal && newVal.records) {
          this.chartKey++; // force apexchart re-render
        }
      },
      deep: true
    }
  },
  methods: {
    async getMemberByPlan(gid = '') {
      let url = "v2/rep-analytics/member-by-carrier";
      if (gid) {
        url = url + '?gid=' + gid;
      }
      await Api.get(url)
        .then((res) => {
          this.memberByPlan = { ...res.data };
          this.modalData = res.data;

        })
        .catch(() => {
          this.memberByPlan = {};
        })
        .finally(() => {
          this.$emit("hide-loader", "totalMembersByIndividualPlan");
        });
    },
    openModal() {
      this.showModal = true;
    },
  },
  created() {
    this.getMemberByPlan();
  },
  computed: {
    getComputedChartOptions() {
      let options = {
        chart: {
          height: 400,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [0, 0, 0],
        },
        xaxis: {
          categories: [],
        },
        legend: {
          show: true,
          position: "top",
        },
      };
      if (!this.memberByPlan["records"]) {
        return options;
      }
      let items = this.memberByPlan.records.slice(0, this.xaxisTotal);
      options.xaxis.categories = items.map((data) => {
        let str = data.carrier_name.substring(0, this.xaxisLabelLength);
        if (data.carrier_name.length >= this.xaxisLabelLength) {
          return [
            str,
            data.carrier_name.substring(
              this.xaxisLabelLength,
              2 * this.xaxisLabelLength
            ),
          ];
        } else {
          return str;
        }
      });
      return options;
    },
    getComputedSeries() {
      if (!this.memberByPlan["records"]) {
        return [];
      }
      let items = this.memberByPlan.records.slice(0, this.xaxisTotal);
      return [
        {
          name: "Members",
          type: "column",
          data: items.map((data) => data.total),
        },
      ];
    },
  },
};
</script>